export class NotFoundError extends Error {
    error?: unknown;
    constructor(message: string, error?: unknown) {
        super(message);
        this.name = 'Not Found';
        this.error = error;
    }
}
